export enum ChartComponent {
    None,
    Google,
    Apex,
    PrimeNG,
    Sunburst
}
